import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = { class: "row d-flex align-items-center mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-8" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Vacation Contribution Summary")
], -1)
const _hoisted_4 = { class: "col-md-2 text-center" }
const _hoisted_5 = { class: "col-md-2 text-center" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-4 border d-flex flex-column justify-content-around gap-4 p-4 py-8" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, " Employer Contributions To Date For Year ", -1)
const _hoisted_9 = { href: ".vacation.details', ['fromDate' => FromDate, 'toDate' => ToDate]" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, " Check Destination: ", -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-stretch gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary w-100" }, "View My Beneficiaries")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary w-100" }, "Add New Beneficiary")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_VacationSummaryChart = _resolveComponent("VacationSummaryChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: `/participant/vacation/summary/${parseInt($setup.year) - 1}`,
          class: "btn btn-primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Previous Year")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: `/participant/vacation/summary/${parseInt($setup.year) + 1}`,
          class: "btn btn-primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Next Year")
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _hoisted_8,
          _createTextVNode(" : "),
          _createElementVNode("a", _hoisted_9, _toDisplayString($setup.vacationData?.TotalContributions), 1)
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, { to: { name: 'participant.vacation.benefits-history' } }, {
            default: _withCtx(() => [
              _createTextVNode("View Payment History")
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, { to: { name: 'participant.vacation.check-replacement' } }, {
            default: _withCtx(() => [
              _createTextVNode("Check Replacement Request")
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_10,
          ($setup.vacationData?.Vacation.VacationCheckDestination)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.vacationData?.Vacation.VacationCheckDestination), 1))
            : _createCommentVNode("", true)
        ]),
        _hoisted_12
      ]),
      ($setup.vacationData)
        ? (_openBlock(), _createBlock(_component_VacationSummaryChart, {
            key: 0,
            "graph-data": $setup.vacationData.GraphData
          }, null, 8, ["graph-data"]))
        : _createCommentVNode("", true)
    ])
  ]))
}